import { render, staticRenderFns } from "./new.vue?vue&type=template&id=3a7c5f96&"
import script from "./new.vue?vue&type=script&lang=js&"
export * from "./new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a7c5f96')) {
      api.createRecord('3a7c5f96', component.options)
    } else {
      api.reload('3a7c5f96', component.options)
    }
    module.hot.accept("./new.vue?vue&type=template&id=3a7c5f96&", function () {
      api.rerender('3a7c5f96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/affaire/new.vue"
export default component.exports